// localStorage key for the next successful sign-in auto product selection.
export const AUTH_APP_AUTO_SELECT_STORAGE_KEY = 'app_auto_select';

// Prefix for per-user last Portfolio in-app path (`${prefix}_${userId}`).
export const AUTH_PORTFOLIO_PREVIOUS_ROUTE_STORAGE_KEY_PREFIX = 'portfolio_previous_route';

// Stored value: resume Portfolio Valuation after sign-in when access allows.
export const PORTFOLIO_VALUATION = 'PORTFOLIO_VALUATION' as const;

// Stored value: resume Company Valuations after sign-in when access allows.
export const COMPANY_VALUATIONS = 'COMPANY_VALUATIONS' as const;

// Legacy stored value kept only for one-time migration of existing user preferences.
export const LEGACY_COMPANY_VALUATIONS_AUTO_SELECT = 'DASHBOARD_409A' as const;
